import React from "react";
import { PatientTypes, PatientTypesEnum } from "../constants";

export const Statuses = ({ status }) => {
  const backgroundColor =
    PatientTypesEnum?.[status] === PatientTypesEnum.HOME
      ? "#FFFBEB"
      : PatientTypesEnum?.[status] === PatientTypesEnum.SNF
        ? "#EEF2FF"
        : "#ECFDF5";

  const color =
    PatientTypesEnum?.[status] === PatientTypesEnum.HOME
      ? "#D97706"
      : PatientTypesEnum?.[status] === PatientTypesEnum.SNF
        ? "#4F46E5"
        : "#059669";

  return (
    status && (
      <div
        className="patient-statuses-wrapper"
        style={{
          background: backgroundColor,
          color: color,
        }}
      >
        <div
          className="patient-statuses-round"
          style={{
            background: color,
          }}
        />
        {PatientTypes?.[status]}
      </div>
    )
  );
};
